// Modules
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Textarea from 'react-textarea-autosize';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';
import ImportChecklist from 'components/models/ticket/import-checklist';

// Utils
import { ignoreEnter } from 'utils/event-handlers';


export default class AddTask extends React.Component {
  static propTypes = {
    saveTask: PropTypes.func.isRequired,
    updateTicket: PropTypes.func.isRequired,
    cancelAddTask: PropTypes.func.isRequired,
    ticket: PropTypes.object.isRequired,
    autoFocus: PropTypes.bool
  };

  constructor() {
    super();
    this.state = {};

    this.updateNewTask = this.updateNewTask.bind(this);
    this.saveTask = this.saveTask.bind(this);
    this.toggleImporting = () => this.setState({ importing: !this.state.importing });
  }

  componentDidMount() {
    if (this.props.autoFocus) ReactDOM.findDOMNode(this.input).focus();
  }

  updateNewTask(event) {
    this.setState({ newTask: event.target.value });
  }

  saveTask(event) {
    if (!event.target.value.length) return;
    
    this.props.saveTask(event.target.value);
    this.setState({ newTask: '' });
  }

  render() {
    const { cancelAddTask, updateTicket, ticket, saveTask } = this.props;
    const { newTask, importing } = this.state;

    return (
      <div className="add-task ticket-form d-flex flex-row justify-content-between">
        <Textarea
          ref={input => { this.input = input; }}
          placeholder="Add a task"
          className="unstyled-textarea"
          onKeyPress={ignoreEnter(this.saveTask)}
          value={newTask}
          onChange={this.updateNewTask}
        />
        <div className="d-flex">
          <Tooltip className="checklist-import-toggle" title="Import Tasks from Praece Know">
            <SVG onClick={this.toggleImporting} className="hoverable" src="svg/import-checklist.svg" />
          </Tooltip>
          <SVG onClick={cancelAddTask} className="close" src="svg/close.svg" />
        </div>

        { importing && <ImportChecklist disableImporting={this.toggleImporting} saveTask={saveTask} updateTicket={updateTicket} ticket={ticket} /> }
      </div>
    );
  }
}
